import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getReportedAbsence = (
    token: string,
    backend: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}employee_absence/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getReportedAbsence;
